<template>
  <div>
    <b-table
      striped
      responsive
      :items="permissionData"
      class="mb-0"
    >

      <template #cell(module)="data">
        {{ data.value }}
      </template>
      <template #cell()="data">
        <b-form-checkbox
          v-model="data.value"
          @change="changeActionStatus(data)"
        />
      </template>
    </b-table>
    <b-button
      v-if="$can('write', 'roles')"
      :disabled="isNew && !newRoleName || saveBtnLoading"
      variant="primary"
      class="mt-1"
      :loading="saveBtnLoading"
      @click="saveRole"
    >
      <b-spinner
        v-if="saveBtnLoading"
        small
      />
      <span v-else>Save</span>
    </b-button>
  </div>
</template>

<script>
import {
  BTable, BFormCheckbox, BButton, BSpinner,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'
import router from '@/router'
import { GOVERNMENTAL, AVAILABLE_PERMISSIONS } from '@/utils/is-governmental-role'

export default {
  components: {
    BTable, BFormCheckbox, BButton, BSpinner,
  },
  props: {
    role: {
      type: Object,
      default: () => ({}),
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    newRoleName: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const isRoleGovernmental = () => props.role.name === GOVERNMENTAL
    const toast = useToast()
    const permissionData = ref([])
    let abilitySubjects = []
    if (props.role.name === GOVERNMENTAL) {
      abilitySubjects = AVAILABLE_PERMISSIONS
    } else {
      abilitySubjects = [
        'dashboard',
        'supply-and-demand',
        'zones/services',
        'roles',
        'transaction-types',
        'versions',
        'drivers',
        'drivers-license',
        'verified-drivers',
        'unverified-drivers',
        'drivers-location',
        'blocked-drivers',
        'reset-pending-transactions',
        'drivers-registration-reports',
        'driver-wallet-settings',
        'driver-wallet-transactions',
        'first-time-transaction',
        'driver-inactivations',
        'driver-notes',
        'driver-devices',
        'learning-center-management',
        'transaction-actions',
        'visa-transactions',
        'users',
        'user-notes',
        'user-wallet-transactions',
        'max-wallet-transactions',
        'vendors',
        'voucher-cards',
        'payout-actions',
        'payout-actions-basics',
        'payout-actions-pay',
        'transaction-bulks',
        'trips',
        'trips-filter',
        'trips-config',
        'fraud-trips',
        'release-trip',
        'create-trip',
        'heatmap',
        'schedules',
        'promo-codes',
        'support-and-complaints',
        'get-otp-users',
        'get-otp-drivers',
        'notifications',
        'logs',
        'templates',
        'dispatch-configurations',
        'groups',
        'pricing-override',
        'tiers',
        'rewards',
        'templates',
        'fine-events',
        'bill-modifications',
        'announcement',

        'advertisement',
        'splash-screen',
        'businesses-orders',
        'businesses-list',
        'businesses-pending-approvals',
        'businesses-tags',
        'businesses-document-types',
        'businesses-heros',
        'businesses-types',
        'violations',
        'drivers-violations',
        'drivers-quiz',

        'teams',
        'group-session',
        'jobs',
        'subscriptions',
        'pricing-overrides',
      ]
    }
    const abilityActions = ['read']
    if (!isRoleGovernmental()) {
      abilityActions.push('write')
      abilityActions.push('delete')
    }
    const saveBtnLoading = ref(false)

    abilitySubjects.forEach(abilitySubject => {
      const permissionRow = {
        module: abilitySubject,
      }
      abilityActions.forEach(abilityAction => {
        permissionRow[abilityAction] = false
      })
      if (!props.isNew) {
        props.role.ability.forEach(r => {
          if (r.subject === abilitySubject) {
            permissionRow[r.action] = true
          }
        })
      }
      permissionData.value.push(permissionRow)
    })

    const changeActionStatus = checkBoxCell => {
      const permissionAction = checkBoxCell.field.key
      // eslint-disable-next-line no-param-reassign
      checkBoxCell.item[permissionAction] = checkBoxCell.value
    }

    const saveRole = () => {
      saveBtnLoading.value = true
      const ability = []
      let roleName = ''
      if (props.isNew) {
        roleName = props.newRoleName
      } else {
        roleName = props.role.name
      }
      permissionData.value.forEach(permission => {
        abilityActions.forEach(abilityAction => {
          if (permission[abilityAction]) {
            ability.push({
              subject: permission.module,
              action: abilityAction,
            })
          }
        })
      })
      store.dispatch('roles/putRole', { roleName, ability }).then(() => {
        if (props.isNew) {
          router.push('/users/roles/list')
        }
        saveBtnLoading.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: props.isNew ? `${props.newRoleName} Saved Successfully` : `${roleName} permissions Saved Successfully`,
            icon: 'CoffeeIcon',
            variant: 'success',
          },
        })
      })
    }
    return {
      permissionData,
      changeActionStatus,
      saveRole,
      saveBtnLoading,
    }
  },
}
</script>

<style>

</style>
